export default __webpack_public_path__ + "static/media/homebuyer-agent.918c054a.jpg";